'use strict'

import './FaqList.css'
import React from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from 'react-accessible-accordion'

function FaqList (props) {

  function getMessage (code) {
    return props.messages.hasOwnProperty(code) ? props.messages[code] : ''
  }

  function categoryFaqList (category_id) {
    let faq_items = props.faqItems.hasOwnProperty(category_id) && Array.isArray(props.faqItems[category_id]) ?
      props.faqItems[category_id] : []

    return faq_items.map(faq_item => {
      let question = faq_item.hasOwnProperty('question') && typeof faq_item.question === 'string' ? faq_item.question : ''
      let answer = faq_item.hasOwnProperty('answer') && typeof faq_item.answer === 'string' ? faq_item.answer : ''

      return <AccordionItem key={faq_item.id} activeClassName={'accordeon_item active'} className={`accordeon_item`}>
        <AccordionItemHeading className={`accordeon_head`}>
          <AccordionItemButton>{question}</AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel className={'accordeon_content'}>
          <span className="text-content faq-accordeon" dangerouslySetInnerHTML={{ __html: answer }}/>
        </AccordionItemPanel>
      </AccordionItem>
    })
  }

  return (
    <>
      {
        props.categories.length ?
          props.categories.map(category => {
            return <div className="section accordeon-section" key={category.id}>
              <div className="section-title"><span>{category.name}</span></div>
              <Accordion allowZeroExpanded={true}
                         allowMultipleExpanded={true}>
                {categoryFaqList(category.id)}
              </Accordion>
            </div>
          }) :
          <></>
      }
    </>
  )
}

export default FaqList